import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Facility } from "@/types/Facility"; // Adjust the import path as needed

interface FacilityState {
    facilities: Facility[];
    loading: boolean;
    error: string | null;
}

const initialState: FacilityState = {
    facilities: [],
    loading: false,
    error: null,
};

const facilitySlice = createSlice({
    name: "facility",
    initialState,
    reducers: {
        // Add a single facility
        addFacility(state, action: PayloadAction<Facility>) {
            state.facilities.push(action.payload);
        },

        // Remove a facility by ID
        removeFacility(state, action: PayloadAction<number>) {
            state.facilities = state.facilities.filter(
                (facility) => facility.id !== action.payload
            );
        },

        // Update an existing facility by matching on ID
        updateFacility(state, action: PayloadAction<Facility>) {
            const updatedFacility = action.payload;
            const index = state.facilities.findIndex(
                (facility) => facility.id === updatedFacility.id
            );
            if (index !== -1) {
                state.facilities[index] = updatedFacility;
            }
        },

        // Replace the entire facilities array
        setFacilities(state, action: PayloadAction<Facility[]>) {
            state.facilities = action.payload;
        },
    },
});

export const {
    addFacility,
    removeFacility,
    updateFacility,
    setFacilities,
} = facilitySlice.actions;

export default facilitySlice.reducer;